import { render, staticRenderFns } from "./WarrantyReturnConfirmationModal.vue?vue&type=template&id=b22723f8&"
import script from "./WarrantyReturnConfirmationModal.vue?vue&type=script&lang=js&"
export * from "./WarrantyReturnConfirmationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports